import Vue from "vue";

const state = Vue.observable({
  isMobile: false
});

function handleResize() {
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

  if (viewportWidth < 800) {
    //on mobile
    state.isMobile = true;
  } else {
    //not on mobile
    state.isMobile = false;
  }
}

window.addEventListener("resize", handleResize);
// run it once to detect initial size:
handleResize();

export default {
  computed: {
    $isMobile() {
      return state.isMobile;
    }
  }
};
